export const checkAppVersion = async () => {
    try {
        const response = await fetch('/api/version');
        if (!response.ok) {
            console.error('Failed to fetch version info', response.status);
            return false;
        }

        const data = await response.json();
        const currentVersion = data.version;
        const storedVersion = localStorage.getItem('app_version');

        if (!storedVersion || storedVersion !== currentVersion) {
            //console.log(`App version changed from ${storedVersion || 'unknown'} to ${currentVersion}`);

            // Clear authentication cookie
            document.cookie = '.AspNetCore.Cookies=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

            // Update stored version
            localStorage.setItem('app_version', currentVersion);

            return true;
        }

        return false; 
    } catch (error) {
        console.error('Error checking application version:', error);
        return false;
    }
};